import { render, staticRenderFns } from "./MainLeftMenu.vue?vue&type=template&id=2451c188&"
import script from "./MainLeftMenu.vue?vue&type=script&lang=js&"
export * from "./MainLeftMenu.vue?vue&type=script&lang=js&"
import style0 from "./MainLeftMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports